import React, { useState, useContext } from 'react'
import { BufferService, NavigateContext, LoadingContext, M_Table, M_MessageBoard, M_Button, M_InputTextField } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import './quotes.css'

export default function Quotes({ roles }) {

    const [refresh, setRefresh] = useState(false)
    const [dialog, setDialog] = useState(false)
    const [valueDelete, setValueDelete] = useState("")
    const pricePlan = new BufferService('PricePlan')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('quotesForm', t("CreateQuote"))
            return
        }

        let tempData = data
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null' || tempData.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        ctx.passValue.set('lines', data)
        if (operation === 'edit') {
            ctx2.newTab('quotesForm', t("EditQuote"))
            return
        }

        if(operation === 'view'){
            ctx2.newTab('quotesForm', t("ViewQuote"))
            return
        }
    }

    const removeContextItems = ['Print', 'View', 'Copy']

    const verifyLineSelect = (data) => {
        let tempData = data
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null' || tempData.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        setDialog(true)
        ctx.passValue.set('lines', tempData)
    }

    const deleteQuoteLine = () => {
        const tempData = ctx.passValue.get("lines") || []
        if (valueDelete === 'delete') {
            if(Array.isArray(tempData)){
                ctx.passValue.delete('lines')
                tempData.forEach(obj => {
                    deleteFunc(obj.Id)
                })
                return
            }
            deleteFunc(tempData.Id)
        } else {
            ctx.toastMessages('error', '', t("labelDeleteQuote"))
        }
    }

    function deleteFunc (id){
        pricePlan.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorQuote"))
                return;
            }
            ctx.toastMessages('success', '', t("SuccessQuoteDeleted"))
            setRefresh(true)
            setDialog(false)
            setValueDelete("")
        })
    }

    return (
        <div className='backgroundForms'>
            < div >
                <div className='divPrincipalTitleRangeKilometers'>
                    <div className='divTitleRangeKilometers'>
                        {t("Quotes")}
                    </div>
                </div>
                <div>
                    <M_Table
                        roleName={'quote'}
                        filtersOnTable
                        entityName={'PricePlan'}
                        removeContextItems={removeContextItems}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        rolePermissions={roles}
                        replaceFunctions={new Map([
                            ['Delete', (data) => verifyLineSelect(data)],
                            ['Create', (data) => NewRoute('', '', 'create', data)],
                            ['Edit', (data) => NewRoute('', '', 'edit', data)]
                        ])}
                        extraButtons={[
                            { label: t('View'), element: 'default', source: '/icons/svgsDaNet/eye-blue.svg', style: {}, command: (data) => NewRoute('', '', 'view', data) }
                        ]}
                    />
                </div>
                <div className='dividerTables'></div>
            </div>

            <M_MessageBoard
                warning
                open={dialog}
                onClose={() => { setDialog(false) }}
                title={"Confirm Delete"}
                body={<div>
                    <div style={{ textTransform: "lowercase" }}>
                        {t("Type")} "<span style={{ color: "red" }}>Delete</span>" {t("DeletePermanently")} <br /> {t("selectedQuotes")}
                    </div>
                    <div>
                        <M_InputTextField
                            label={""}
                            secondColor={"var(--color-red-dark)"}
                            value={valueDelete}
                            onChange={(e) => setValueDelete(e.target.value)}
                        />
                    </div>
                </div>}
                footer={<div className='divButtonsDelete'>
                    <M_Button backgroundColor="var(--color-red-dark)" labelColor={"var(--color-white)"} label="Cancel" hoverEffect onClick={() => setDialog(false)} />
                    <M_Button backgroundColor="var(--color-green-dark)" labelColor={"var(--color-white)"} label="Confirm" hoverEffect onClick={() => deleteQuoteLine()} />
                </div>}
            />
        </div >
    )
}
